import React, { useState, useEffect } from "react";
import store from "../reduxstore";
import { hasExactRole } from "../auth";
import SERVER_ADDRESS from "../config";

const testNames = {
  a: "构件辨识实验",
  b: "平身科搭建实验",
  c: "柱额层搭建实验",
  d: "斗栱层搭建实验",
  e: "屋架层搭建实验",
  f: "椽望层搭建实验"
};
const stateUrl = `${SERVER_ADDRESS}/ilabx/uploadstate/`;
const gradeUrl = `${SERVER_ADDRESS}/ilabx/uploadgrade/`;

async function startTestState() {
  if (hasExactRole("实验空间学生")) {
    const response = await fetch(stateUrl, {
      mode: "cors",
      credentials: "include"
    }).then(res => {
      return res.json();
    });
    console.log(response);
  }
}

async function returnTestGrade(testType, grade, timeCost) {
  if (hasExactRole("实验空间学生")) {
    let h = new Headers();
    h.append("Accept", "application/*");

    let formdata = new FormData();
    formdata.append("test_type", testType);
    formdata.append("grade", grade);
    formdata.append("time_cost", timeCost);

    let req = new Request(gradeUrl, {
      method: "POST",
      headers: {
        Accept: "application/*, text/plain, */*"
      },
      mode: "cors",
      credentials: "include",
      body: formdata
    });

    const response = await fetch(req).then(res => {
      return res.json();
    });
    console.log(response);
  } else {
    console.log("not ilabx user");
  }
}

//custom hook to upload test state
function useTestState() {
  useEffect(() => {
    startTestState();
  }, []);
}

//custom hook to calculate time
function useStartTime() {
  const [startTime, setStartTime] = useState(new Date());
  return startTime;
}
export { startTestState, returnTestGrade, useTestState, useStartTime };
